import Vue from 'vue';
import App from './App.vue';
import '@/assets/styles/common.scss'; // global css
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './permission'; // permission control
Vue.use(ElementUI);
import router from '@/router';
import store from './store';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// 引入jQuery
import jquery from 'jquery'
// 将jQuery绑定到Vue实例的原型上，方便全局使用
Vue.prototype.$jquery = jquery
Vue.config.productionTip = false;
import moment from 'moment';
moment.locale('zh-cn');
Vue.prototype.$moment = moment;
ElementUI.Dialog.props.closeOnClickModal.default = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
